<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-md-12">
        <loading v-if="! showContent"></loading>
        <h2 class="titulo">{{ title }}</h2>
        <div class="row">
          <div class="col-md-3" v-for="item in items">
            <router-link :to="getUrl(item.id, item.name)" class="evento">
              <img v-if="item.image" :src="item.image"/>
              <img v-if="!item.image" src="dist/images/sem_imagem.jpg"/>
              <span>
                <i class="fa fa-calendar" aria-hidden="true"></i> {{ item.dateInit }}
                <i class="fa fa-clock-o" aria-hidden="true"></i> {{ item.hourInit }}
              </span>
              {{ item.name }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../helpers/api';
  import Loading from '../components/common/Loading.vue';
  import {slugify} from '../helpers/slugify';

  export default {
    components: {
      Loading
    },
    data() {
      return {
        title: 'Eventos',
        showContent: false,
        items: []
      }
    },
    created() {
      let self = this;
      get('events').then(function (response) {
        self.items = response.data.result.data;
        self.showContent = true;
      });
    },
    methods: {
      getUrl(id, string) {
        return '/evento/' + id + '/' + slugify(string);
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/Events.vue